import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { rgpd } from '../middlewares/rgpd';
import rootReducer from '../reducers';

export const configureStore = (preloadedState) =>
  createStore(rootReducer, preloadedState, applyMiddleware(thunk, rgpd));

export default configureStore;
